// extracted by mini-css-extract-plugin
export default {"popupOverlay":"success_popupOverlay__n09n1","login_container":"success_login_container__2lQ4R","closeButton":"success_closeButton__yNw8O"};